import { ref } from 'vue';
import { defineStore } from 'pinia';
import { MetaOptions } from 'quasar/dist/types/meta';

export const useMetaStore = defineStore('metaTagsStore', () => {
  const metaTags = ref<MetaOptions>();

  const setMetaTags = (data: MetaOptions) => {
    metaTags.value = data;
  };

  return {
    metaTags,
    setMetaTags,
  };
});
